import { APITypes } from "@cur8/api-client";
import { useQuery } from "@tanstack/react-query";
import { BookingResource } from "lib/api/booking-resource";
import { APIClient } from "lib/api/client";
import { DateTime } from "luxon";
import { useCallback } from "react";
import { useAPIClient } from "render/context/APIContext";
import { useSession } from "render/context/MSALContext";

async function getUpcomingFreeSlotsForPatient(
  apiClient: APIClient,
  patientId: string
) {
  const buffer: APITypes.Slot[] = [];

  // Limit to 3 months and a 1000 slots
  const limit = 1000;
  const limitTo = DateTime.now().plus({ months: 2 }).endOf("month");

  let nextPage: string | undefined;
  try {
    do {
      const res = await apiClient.booking.getUpcomingFreeSlotsForPatient({
        patientId,
        bookingResourceUri: BookingResource.B2CClinic.toString(),
        limit,
        endTime: limitTo.toISO(),
        continuationToken: nextPage,
      }).result;

      buffer.push(...res.items);
      nextPage = res.nextPage;
    } while (nextPage);
  } catch (err) {
    if ((err as any)?.response?.status !== 404) {
      throw err;
    }
    // The patient does not have appropriate conditions
    // to fetch slots available for them, so don't pay attention to 404
  }
  return buffer;
}

function queryKey() {
  return ["booking-slots", "free"];
}

export function useOpenSlotsQuery() {
  const apiClient = useAPIClient();
  const { patientId } = useSession();
  const queryFn = useCallback(
    () => getUpcomingFreeSlotsForPatient(apiClient, patientId),
    [apiClient, patientId]
  );

  return useQuery({
    queryKey: queryKey(),
    queryFn: queryFn,
    enabled: false,
  });
}
